import React from "react";
import DataView from "./dataView";

const BusinessDataView = () => {
	return <DataView section="business" />;
};

export default BusinessDataView;
